export const Global = {
    equalize: function () {
        var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (document.querySelector(".page-navigation-container") && w >= 992) {
            var tallest = 0;
            
            document.querySelectorAll('.page-navigation-block-panel, .supply-water-link-list-block, .waste-search-block').forEach(index => {
                if (tallest < index.offsetHeight) {
                    tallest = index.offsetHeight;
                }
            });

            document.querySelectorAll('.page-navigation-block-panel, .supply-water-link-list-block, .waste-search-block').forEach(index => {
                index.style.minHeight = tallest + "px";
            });
        }
    },
    alternateContent: function () {
        if(!window['OptanonActiveGroups'].includes("C0003")) {
            /*
                OneTrust saves which cookie categories are accepted in the OptanonActiveGroups object.
                Cookie categories:
                C0001 = Necessary
                C0002 = Performance
                C0003 = Functional (This category must be accepted to see the embedded content in the current implementation)
                C0004 = Targeting
                C0005 = Social Media
            */
            // video block and video list block
            let containers = document.querySelectorAll('.video-container');
                containers = [...containers, ...document.querySelectorAll('.video-list-block')];
            // service map embed block
                containers = [...containers, ...document.querySelectorAll('.service-map-embedded-block .js-external-content')];
            // iframe block and water supply map block (uses iframe-block class)
                containers = [...containers, ...document.querySelectorAll('.iframe-block .js-external-content')];
            const alternateContent = document.querySelector('.js-generic-data').dataset.alternateContent;
            containers.forEach(index => {
                index.innerHTML = alternateContent;
                index.style.height = "auto";
            });
        }
        window.OneTrust.OnConsentChanged(() => {
            location.reload();
        });
    },
    setExternalLinks: function () {
        const links = document.querySelectorAll('a');        
        links.forEach((link) => {
            //Link is not in the main content area / hero content area / content-area / bottom-content-area / front page lifts area, do not manipulate
            
            if(!link.closest('.main-content-area') &&
               !link.closest('.hero-content') &&
               !link.closest('.content-area') &&
               !link.closest('.bottom-content-area') &&
               !link.closest('.lifts-content-area')) return;
            const targetUrl = new URL(link.href, document.baseURI);
            const isDifferentHostname = targetUrl.hostname !== window.location.hostname;
            if(isDifferentHostname) {
                // Target all svg:s inside the link
                const icons = link.querySelectorAll('svg');
                if(!icons.length) {
                    // Link does not contain any svg, add external link icon
                    link.insertAdjacentHTML('beforeend', '<svg class="icon icon-hsy-icon-external-link" aria-hidden="true" focusable="false"><use xlink:href="#icon-hsy-external-link"></use></svg>');
                    link.classList.add('external-link');
                }
                // There are elements that have more than one svg inside them, we need to target the correct one
                icons.forEach(icon => {
                    if(icon.classList.contains('icon-hsy-icon-arrow-right-short-bold')) {
                        // Link is an external link, remove default icon and...
                        icon.classList.remove('icon-hsy-icon-arrow-right-short-bold');
                        // ...add external link icon
                        icon.classList.add('icon-hsy-icon-external-link');
                        icon.querySelector('use').setAttribute('xlink:href', '#icon-hsy-external-link');
                    }                        
                });
            }
        });    
    },
    observeAccordionChanges: function () {
        const observer = new MutationObserver((mutationsList, observer) => {
            const accordions = document.querySelectorAll('.accordion');
            if (accordions.length > 0) {
                // Disconnect the global observer once we�ve found the accordions
                observer.disconnect();

                // Observe each accordion for content changes
                const accordionContentObserver = new MutationObserver(() => {
                    Global.setExternalLinks();
                });

                accordions.forEach(accordion => {
                    accordionContentObserver.observe(accordion, { childList: true, subtree: true });
                });

                // Also run once immediately in case content is already there
                Global.setExternalLinks();
            }
        });

        // Start watching the body for added nodes
        observer.observe(document.body, { childList: true, subtree: true });
    },
    initLinkObserver: function () {
        this.setExternalLinks(); // Initial call for external links
        this.observeAccordionChanges(); // Start observing accordion changes
    }
}
// Self invoking function bound to listen to OneTrust event, semicolon at the beginning to please ESLint
;(function() {
    window.addEventListener("DOMContentLoaded", () => {
        Global.initLinkObserver();
        if(!window.OneTrust) {
            const ensureOnetrust = setInterval(() => {
                if(!window.OneTrust) return; // Onetrust is not ready yet, take another lap
                clearInterval(ensureOnetrust);
                Global.alternateContent();
            },50);
        } else {
            Global.alternateContent();
        }
    });
})();